/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} MarketplaceInputs */

const en_marketplace = /** @type {(inputs: MarketplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marketplace`)
};

const es_marketplace = /** @type {(inputs: MarketplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mercado`)
};

const fr_marketplace = /** @type {(inputs: MarketplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marketplace`)
};

const de_marketplace = /** @type {(inputs: MarketplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marktplatz`)
};

const ja_marketplace = /** @type {(inputs: MarketplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マーケットプレイス`)
};

const zh_marketplace = /** @type {(inputs: MarketplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`市场`)
};

const ar_marketplace = /** @type {(inputs: MarketplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`السوق`)
};

const id_marketplace = /** @type {(inputs: MarketplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marketplace`)
};

const it_marketplace = /** @type {(inputs: MarketplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marketplace`)
};

const ru_marketplace = /** @type {(inputs: MarketplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Маркетплейс`)
};

const pt_marketplace = /** @type {(inputs: MarketplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marketplace`)
};

const ko_marketplace = /** @type {(inputs: MarketplaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`마켓플레이스`)
};

/**
* | output |
* | --- |
* | "Marketplace" |
*
* @param {MarketplaceInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const marketplace = /** @type {((inputs?: MarketplaceInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<MarketplaceInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketplace(inputs)
	if (locale === "es") return es_marketplace(inputs)
	if (locale === "fr") return fr_marketplace(inputs)
	if (locale === "de") return de_marketplace(inputs)
	if (locale === "ja") return ja_marketplace(inputs)
	if (locale === "zh") return zh_marketplace(inputs)
	if (locale === "ar") return ar_marketplace(inputs)
	if (locale === "id") return id_marketplace(inputs)
	if (locale === "it") return it_marketplace(inputs)
	if (locale === "ru") return ru_marketplace(inputs)
	if (locale === "pt") return pt_marketplace(inputs)
	return ko_marketplace(inputs)
});